import { createStyles, makeStyles } from "@material-ui/styles";
import {
    Attachment,
    Button,
    DocViewer,
    docViewerUrl,
    DownloadIcon,
    ExternalLinkIcon,
    RelodeTheme,
    Text,
} from "@relode/core";
import * as React from "react";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                padding: theme.spacing(2, 3, 3, 3),
                height: "100%",
                flex: 1,
                display: "flex",
                flexDirection: "column",
            },
            controlBar: {
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                marginBottom: theme.spacing(2),
            },
            docViewerWrapper: {
                flex: 1,
            },
            downloadButton: {
                width: 180,
            },
            buttonIcon: {
                marginRight: theme.spacing(1),
            },
            openButton: {
                width: 180,
                marginLeft: theme.spacing(2),
            },
            noResults: {
                padding: theme.spacing(3),
                textAlign: "center",
            },
        }),
    { name: "CandidateResumeDesktop" }
);

interface CandidateResumeDesktopProps {
    resume: Attachment;
}
export const CandidateResumeDesktop = (props: CandidateResumeDesktopProps) => {
    const classes = useStyles({});
    const { resume } = props;
    const extendedId = "CandidateResumeDesktop";

    const handleOpen = (resumeUrl: string) => {
        window.open(resumeUrl);
    };

    return (
        <div className={classes.root} id={`${extendedId}Wrapper`}>
            {resume ? (
                <>
                    <div
                        className={classes.controlBar}
                        id={`${extendedId}ResumeControlBar`}
                    >
                        <Button
                            size="small"
                            className={classes.downloadButton}
                            onClick={() => handleOpen(resume.fileUri)}
                            title="download resume"
                        >
                            <DownloadIcon
                                color="inherit"
                                className={classes.buttonIcon}
                            />{" "}
                            download
                        </Button>
                        <Button
                            size="small"
                            className={classes.openButton}
                            onClick={() =>
                                handleOpen(
                                    docViewerUrl(
                                        resume.fileUri,
                                        resume.contentType,
                                        resume.fileExtension
                                    )
                                )
                            }
                            title="open in new window"
                        >
                            <ExternalLinkIcon
                                color="inherit"
                                className={classes.buttonIcon}
                            />
                            pop out
                        </Button>
                    </div>
                    <div
                        className={classes.docViewerWrapper}
                        id={`${extendedId}ResumeDocViewerWrapper`}
                    >
                        <DocViewer
                            docKey="resumeView"
                            docUrl={resume.fileUri}
                            docType={resume.contentType}
                            docExtension={resume.fileExtension}
                        />
                    </div>
                </>
            ) : (
                <Text
                    variant="h4"
                    color="primary"
                    className={classes.noResults}
                >
                    Resume not available.
                    <br />
                    Please contact your Job Manager.
                </Text>
            )}
        </div>
    );
};
